export const parseAndSplitHtmlText = (input: string) =>
  input.replace(/\&quot\;/g, `"`).split('<br />');
